<template lang="pug">
.simple-sidebar
  .simple-sidebar__menu-list
    FAQSidebarBody
</template>

<script lang="ts">
  import { defineComponent } from 'vue'
  import Icon from '@/components/Atoms/Icon.vue'
  import FAQSidebarBody from './FAQSidebarBody.vue'

  export default defineComponent({
    name: 'FAQSidebar',
    components: {
      Icon,
      FAQSidebarBody,
    },
  })
</script>

<style lang="stylus">
  a
    text-decoration: none;
    color: #2F3242
    &:hover,
    &:focus
      text-decoration: none;
      color: #2F3242
  .simple-sidebar
    font-size: 1rem
    height: 100%
    margin: 0
    padding: 1.8rem
    background-color: #fff
</style>
